export default {
  //Login images
  login_image: require("./login_image.png"),
  //Home images
  home_bot_left: require("./home_bot_left.png"),
  home_bot_right: require("./home_bot_right.png"),
  menu_profile: require("./menu_profile.png"),
  menu_home: require("./menu_home.png"),
  menu_assignment: require("./menu_assignment.png"),
  menu_classes: require("./menu_classes.png"),
  menu_notifications: require("./menu_notifications.png"),
  menu_profile_sr: require("./menu_profile_sr.svg"),
  menu_home_sr: require("./menu_home_sr.svg"),
  menu_assignment_sr: require("./menu_assignment_sr.svg"),
  menu_classes_sr: require("./menu_classes_sr.svg"),
  menu_notifications_sr: require("./menu_notifications_sr.svg"),
  menu_logout: require("./menu_logout.png"),
  lesson_thumbnail: require("./lesson_thumbnail.png"),
  class_image: require("./class_image.png"),
  empty_anim_3: require("./Empty_anim_03.png"),
  //Activity card images
  ActivityPink: require("./ActivityPink.png"),
  ActivityBlue: require("./ActivityBlue.png"),
  ActivityPurple: require("./ActivityPurple.png"),
  ActivityYellow: require("./ActivityYellow.png"),
  activity_thumbnail: require("./activity_thumbnail.png"),
  //Activity type images
  smart_tile_icon: require("./smart_tile_icon.png"),
  smart_tile_icon_selected: require("./smart_tile_icon_seletced.png"),
  smart_slide_icon: require("./smart_slide_icon.png"),
  smart_slide_icon_selected: require("./smart_slide_icon_selected.png"),
  smart_paper_icon: require("./smart_paper_icon.png"),
  smart_paper_icon_selected: require("./smart_paper_icon_selected.png"),
  smart_label_icon: require("./smart_label_icon.png"),
  smart_label_icon_selected: require("./smart_label_icon_selected.png"),
  //Smart label modes images
  label_type: require("./label_type.png"),
  label_shuffle: require("./label_shuffle.png"),
  label_select: require("./label_select.png"),
  label_match: require("./label_match.png"),
  label_answer: require("./label_answer.png"),
  label_type_selected: require("./label_type_selected.png"),
  label_shuffle_selected: require("./label_shuffle_selected.png"),
  label_select_selected: require("./label_select_selected.png"),
  label_match_selected: require("./label_match_selected.png"),
  label_answer_selected: require("./label_answer_selected.png"),
  //Smart paper toolbar images
  stroke_pen: require("./stroke_pen.png"),
  stroke_pen_red: require("./stroke_pen_red.png"),
  stroke_pen_black: require("./stroke_pen_black.png"),
  stroke_pen_yellow: require("./stroke_pen_yellow.png"),
  stroke_pen_blue: require("./stroke_pen_blue.png"),
  shape_select: require("./shape_select.png"),
  shape_unselect: require("./shape_unselect.png"),
  shape_disable: require("./shape_disable.png"),
  select_arrow_unselect: require("./select_arrow_unselect.png"),
  select_arrow_select: require("./select_arrow_select.png"),
  select_arrow_disable: require("./select_arrow_disable.png"),
  label_add_unselect: require("./label_add_unselect.png"),
  label_add_select: require("./label_add_select.png"),
  label_add_disable: require("./label_add_disable.png"),
  voice_recordning: require("./voice_recording.png"),
  voice_recordning_disable: require("./voice_recording_disable.png"),
  replay_select: require("./replay_select.png"),
  replay_unselect: require("./replay_unselect.png"),
  delete: require("./delete.png"),
  //Answer explanation
  help_icon: require("./help.png"),
};
